import gql from "graphql-tag";

export default {

get: gql`
    query ModernPhotoboothCell($id: ID!) {
        photoCell(id: $id) {
            id
        }
    }`
}
